module.exports = __webpack_public_path__ + "h5/img/lottery-bg1.b7b28e65.png";